/*=========================================================================================
  File Name: moduleAdmin.js
  Description: Admin Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleAdminState.js'
import mutations from './moduleAdminMutations.js'
import actions from './moduleAdminActions.js'
import getters from './moduleAdminGetters.js'

export default {
    isRegistered: false,
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}